import { useEffect, useState, useContext } from 'react';
import { CircularProgress } from '@mui/material';
import { Context } from '../../../AuthContext';
import AssignedTasksModal from './AssignedTasksModal';

const AssignedTasksSummary = () => {
  const { user } = useContext(Context);
  const [summary, setSummary] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchSummary = async () => {
    if (!user?.uid) return;
    setLoading(true);
    try {
      const token = await user.getIdToken();
      const res = await fetch(
        process.env.REACT_APP_FLASK_WEBSERVER + 'get_assigned_tasks_summary',
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) return;
      const data = await res.json();
      setSummary(data);
    } catch (err) {
      console.error('Failed to fetch assigned tasks summary', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, [user?.uid]);

  const dueToday = summary?.due_today ?? 0;
  const upcoming = summary?.due_future ?? 0;
  const overdue = summary?.overdue ?? 0;
  const verticals = summary?.verticals ?? [];

  return (
    <div
      style={{
        padding: '12px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '12px',
          fontWeight: 600,
          minWidth: 0,
        }}
      >
        <img src="/task.svg" alt="" style={{ flexShrink: 0 }} />
        <span
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
          }}
        >
          ASSIGNED TASKS
        </span>
      </div>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {loading ? (
          <CircularProgress size={24} style={{ color: '#000' }} />
        ) : (
          <>
            <div
              style={{
                fontSize: '18px',
                fontWeight: 700,
                textDecoration: 'underline',
              }}
            >
              {dueToday} DUE TODAY
            </div>
            <div>{upcoming} Upcoming</div>
            <div>{overdue} Overdue</div>
          </>
        )}
      </div>
      {!loading && verticals.length > 0 && (
        <div
          onClick={() => setModalOpen(true)}
          style={{
            color: '#1976d2',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 700,
            textDecoration: 'underline',
            cursor: 'pointer',
            marginBottom: '12px',
          }}
        >
          See Assigned Tasks
        </div>
      )}
      <AssignedTasksModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        rows={verticals}
      />
    </div>
  );
};
export default AssignedTasksSummary;
